module.exports = __webpack_public_path__ + "f7daab2f11c8e91cfc6cb94621365d9b.jpg";